var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterlogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 7,
    viewBox: "0 0 3 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.286133 6.6711V0.911095H1.28613V6.6711H0.286133ZM0.73613 1.87109V0.871094H2.92613V1.87109H0.73613ZM0.73613 4.2911V3.2911H2.73613V4.2911H0.73613ZM0.73613 6.6711V5.6711H2.92613V6.6711H0.73613Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterlogo2);
export default __webpack_public_path__ + "static/media/footerlogo2.a92eae4050548cf7020915583db79c73.svg";
export { ForwardRef as ReactComponent };